export default "__VITE_ASSET__BDf3lYoA__"